<template>
  <div class="mymng acccont">
    <div class="acctit">
      <div @click="returnpage" class="returnbtn" v-if="isApp"><i class="el-icon-arrow-left"></i></div>
      {{$t('product.financing_order')}}
    </div>
    <div class="flexbox fle-wrap fle-sb">
      <div class="card_order " v-for="(item, index) in lists" :key="index+'order'">
        <div class="cartit_ord flexbox fle-sb">
          <div>{{item.order_sn}}</div>
          <div>{{item.order_status_text}}</div>
        </div>
        <div class="flexbox texal fle-sb">
          <div class="fle2">
            <el-row>
              <el-col :span="12">{{$t('product.product_name')}}: {{item.product_name}}</el-col>
              <el-col :span="12">{{$t('product.product_num')}}: {{item.product_num}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="12">{{$t('product.start_date')}}: {{item.start_time2}}</el-col>
              <el-col :span="12">{{$t('product.end_date')}}: {{item.end_time2}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="12">{{$t('product.create_date')}}: {{item.createtime2}}</el-col>
            </el-row>
            <el-row>
              <el-col :span="12">{{$t('product.order_amount')}}: <span class="colory">{{item.order_amount}}</span></el-col>
              <el-col :span="12">{{$t('product.income_amount')}}: <span class="colory">{{item.income_amount}}</span></el-col>
            </el-row>
          </div>
          <div class="fle1">
            <img :src="item.product.image">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {getOrderList} from '@/api/product'
export default {
  name: 'myMng',
  data () {
    return {
        lists: []
    }
  },
  computed:{
    isApp(){
      return document.documentElement.clientWidth<800?true:false
    },
    routeName(){
      console.log(this.$route.path)
      return this.$route.path
    }
  },
    created() {
        this.getData()
    },
  methods: {
      getData() {
          getOrderList().then(res => {
              console.log(res)
              const data = res.data
              this.lists = data.lists

          }).catch(_ => {

          })
      },
    returnpage(){
      this.$router.go(-1)
    },
    submitForm(){
      if(this.isApp){
        this.$router.push('/home/success')


      }
    },
  }
}
</script>
<style lang="scss" scoped>
.mymng{
  font-size: 18px;
  .card_order{
    width: 45%;
    box-sizing: border-box;
    padding:10px 30px 30px 30px;
    border-radius: 10px;
    line-height: 30px;
    margin: 30px 0px;
    border: 1px solid #6d6d6d;
    font-size: 16px;
    .cartit_ord{
      line-height: 50px;
      border-bottom: 1px solid #6d6d6d;
      margin-bottom: 10px;
      font-size: 18px;
    }
    .fle2{
      flex: 2;
    }
    .fle1{
      img{
        width: 80px;
        height: 80px;
        border-radius: 100%;
      }
    }
  }
}

</style>
